"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YarnVersion = void 0;
exports.YarnVersion = typeof YARN_VERSION !== `undefined`
    ? process.env.YARN_IS_TEST_ENV ? `0.0.0` : YARN_VERSION
    : null;
